import { useState, useEffect } from "react";
import { loadingManager } from "../utils/loadingManager";

export const useGlobalLoading = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = loadingManager.addListener((loading) => {
      setIsLoading(loading);
    });

    return () => unsubscribe();
  }, []);

  return isLoading;
};
